import { Text } from '@interco/inter-ui/components/Text'
import IcArrowLeft from '@interco/icons/core/action-navigation/ic_arrow_left'
import { interWbNavigate } from '@interco/inter-webview-bridge'

import * as S from './styles'

const Header = () => <MobileHeader />

function MobileHeader() {
  const route = window.location.pathname
  const title = () => {
    switch (route) {
      case '/about-account-link':
      case '/about-send-data':
      case '/about-open-finance':
        return 'Sobre'
      case '/register':
        return 'Cadastro'
      case '/account':
        return 'Conta'
      case '/credit-card':
        return 'Cartão de crédito'
      case '/investing':
        return 'Investimentos'
      case '/credit-operations':
        return 'Operações de crédito'
      case '/exchange':
        return 'Câmbio'
      default:
        return 'Voltar'
    }
  }
  return (
    <S.HeaderMobile style={{ flexDirection: 'column' }}>
      <IcArrowLeft
        height={24}
        width={24}
        color="var(--gray500)"
        onClick={() => interWbNavigate.requestGoBack()}
      />
      <Text variant="headline-h3" semiBold style={{ fontFamily: 'Sora', fontSize: 26 }}>
        {title()}
      </Text>
    </S.HeaderMobile>
  )
}

export default Header
